/**
 * +field: the main quest's story panels (docs/design/zones.md "Mossvale's main quest"), drawn into a
 * quest giver's dialog:
 *  - idle_intro (Hearthkeeper Bryn): Auto online earns 100% XP; logged off, the hero keeps grinding
 *    at a reduced, diminishing rate (Phase 2), shown as a simple graphic;
 *  - tower_soon (the Tower Warden): the Tower silhouette and its "coming soon" gate.
 */
import { el } from '../dom';
import { OFFLINE_CAP_H, OFFLINE_FULL_H, offlineAutoHours, offlineRate } from '../../world/idleModel';

export function idleIntroGraphic(parent: HTMLElement): HTMLElement {
  const box = el('div', 'fx-idle', parent);
  // Online: the full bar.
  const on = el('div', 'fx-idle-row', box);
  const onHead = el('div', 'fx-idle-head', on);
  el('span', 'fx-idle-name', onHead, 'Playing, Auto on');
  el('span', 'fx-idle-val on', onHead, '100% XP');
  el('div', 'fx-idle-full', on);
  el('div', 'fx-idle-note', on, 'Auto is a real way to play: no penalty while the game is open.');
  // Offline: the decay curve, one bar per 2 hours.
  const off = el('div', 'fx-idle-row', box);
  const offHead = el('div', 'fx-idle-head', off);
  el('span', 'fx-idle-name', offHead, 'Logged off');
  el('span', 'fx-idle-val off', offHead, 'reduced rate');
  const chart = el('div', 'fx-idle-chart', off);
  for (let h = 0; h < OFFLINE_CAP_H; h += 2) {
    const r = offlineRate(h + 1);
    const bar = el('div', `fx-idle-bar${h < OFFLINE_FULL_H ? ' full' : ''}`, chart);
    bar.style.height = `${Math.max(4, Math.round(r * 100))}%`;
    bar.title = `${h}–${h + 2} h: ${Math.round(r * 100)}%`;
  }
  const axis = el('div', 'fx-idle-axis', off);
  for (const t of ['0h', '6h', '12h', '18h', '24h']) el('span', '', axis, t);
  el(
    'div',
    'fx-idle-note',
    off,
    `Your hero keeps grinding where you left them: full rate for ${OFFLINE_FULL_H} hours, then it halves every 4 hours, up to ${OFFLINE_CAP_H} hours (about ${offlineAutoHours(OFFLINE_CAP_H).toFixed(1)} hours of Auto).`,
  );
  el('div', 'fx-idle-soon', box, 'Offline gains arrive in the next update');
  return box;
}

export function towerGraphic(parent: HTMLElement): HTMLElement {
  const box = el('div', 'fx-tower', parent);
  const sky = el('div', 'fx-tower-sky', box);
  const spire = el('div', 'fx-tower-spire', sky);
  for (let i = 0; i < 6; i++) el('div', 'fx-tower-floor', spire);
  el('div', 'fx-tower-ring', sky);
  el('div', 'fx-tower-beacon', sky);
  el('div', 'fx-tower-caption', box, 'The Tower awaits — coming soon');
  el('div', 'fx-idle-note', box, 'Floor after floor of stronger foes, each with its own level band and a boss on the landing. Mossvale is behind you.');
  return box;
}
